import classes from "./OrLine.module.scss";
type Props = {
  text?: string;
};
export function OrLine({
  text = "or"
}: Props) {
  return <div className={classes.Or} data-sentry-component="OrLine" data-sentry-source-file="OrLine.tsx">
      <span>{text}</span>
    </div>;
}